import { render, staticRenderFns } from "./RegionalDistributionChart.vue?vue&type=template&id=2a931c81&scoped=true"
import script from "./RegionalDistributionChart.vue?vue&type=script&lang=js"
export * from "./RegionalDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./RegionalDistributionChart.vue?vue&type=style&index=0&id=2a931c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a931c81",
  null
  
)

export default component.exports